class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){    
    const lenis = new Lenis();
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
		
		if ($(".js-loop-swiper").length > 0) {
      const loopSwiper = new Swiper(".js-loop-swiper", {
        slidesPerView: 'auto',
        spaceBetween: 6,
        speed: 20000,
        allowTouchMove: false,
        autoplay: {
          delay: 0,
        },
        loop: true,
        breakpoints: {
          768: {
						speed: 30000,
          }
        },
      });
    }

  }
}
